<div class="row">
    <div class="col-xs-12 review-candidate-pull-review-heading-container">
        <span [innerHTML]="reviewHtmlText"></span>
    </div>
    <div class="col-xs-12">
        <div class="main-box clearfix">
            <div class="row">
                <div class="col-xs-8">
                    <div class="review-candidate-pull-counts-heading">Candidate Counts</div>
                </div>
            </div>
            <div class="row review-candidate-pull-counts-row" *ngIf="loadingCountsInfoFlag">
                <div class="col-xs-4 col-xs-offset-4">
                    <h4 style="border-bottom: none;">Processing <i class="fa fa-spin fa-spinner"></i></h4>
                </div>
            </div>
            <div class="row review-candidate-pull-counts-row" *ngIf="!loadingCountsInfoFlag">
                <div class="col-xs-offset-1 col-xs-4">
                    <span>Pulled Candidates :</span>
                    <span class="pull-right">
                        <span *ngIf="candidateCounts.uploadedCandidateCount <= 0">0</span>
                        <a class="cursor-pointer" href="" *ngIf="candidateCounts.uploadedCandidateCount > 0" tooltip="Click to view Pulled Candidates." placement="top-right" container="body" (click)="displayProcessedCandidates('pulled')">{{candidateCounts.uploadedCandidateCount}}</a>
                    </span>
                </div>
                <div class="col-xs-offset-1 col-xs-3">
                    <span>Updated Candidates :</span>
                    <span class="pull-right">
                        <span *ngIf="candidateCounts.updatedCandidateCount <= 0">0</span>
                        <a class="cursor-pointer" href="" *ngIf="candidateCounts.updatedCandidateCount > 0" tooltip="Click to view Updated Candidates." placement="top-right" container="body" (click)="displayProcessedCandidates('updatedCandidates')">{{candidateCounts.updatedCandidateCount}}</a>
                    </span>
                </div>
            </div>
            <div class="row review-candidate-pull-counts-row" *ngIf="!loadingCountsInfoFlag">
                <div class="col-xs-offset-1 col-xs-4">
                    <span>Matched Candidates :</span>
                    <span class="pull-right">
                        <span *ngIf="candidateCounts.autoMatchedCandidateCount <= 0">0</span>
                        <a class="cursor-pointer" href="" *ngIf="candidateCounts.autoMatchedCandidateCount > 0" tooltip="Click to view Matched Candidates." placement="top-right" container="body" (click)="displayProcessedCandidates('autoMatched')">{{candidateCounts.autoMatchedCandidateCount}}</a>
                    </span>
                </div>
                <div class="col-xs-offset-1 col-xs-3">
                    <span>Unmatched Candidates :</span>
                    <span class="pull-right">
                        <span *ngIf="candidateCounts.unmatchedCandidateCount <= 0">0</span>
                        <a class="cursor-pointer" href="" *ngIf="candidateCounts.unmatchedCandidateCount > 0" tooltip="Click to view Unmatched Candidates." placement="top-right" container="body" (click)="displayProcessedCandidates('unMatched')">{{candidateCounts.unmatchedCandidateCount}}</a>
                    </span>
                </div>
            </div>
            <div class="row review-candidate-pull-counts-row" *ngIf="!loadingCountsInfoFlag">
                <div class="col-xs-offset-1 col-xs-4">
                    <span>Manually Matched Candidates :</span>
                    <span class="pull-right">
                        <span *ngIf="candidateCounts.manuallyMatchedCandidateCount <= 0">0</span>
                        <a class="cursor-pointer" href="" *ngIf="candidateCounts.manuallyMatchedCandidateCount > 0" tooltip="Click to view Manually Matched Candidates." placement="top-right" container="body" (click)="displayProcessedCandidates('manuallyMatched')">{{candidateCounts.manuallyMatchedCandidateCount}}</a>
                    </span>
                </div>
                <div class="col-xs-offset-1 col-xs-3">
                    <span>Resumes Not Processed :</span>
                    <span class="pull-right">
                        <span *ngIf="candidateCounts.notProcessedCandidateCount <= 0">0</span>
                        <a class="cursor-pointer" href="" *ngIf="candidateCounts.notProcessedCandidateCount > 0" tooltip="Click to view Resumes Not Processed Candidates." placement="top-right" container="body" (click)="displayProcessedCandidates('resumeNotProcessed')">{{candidateCounts.notProcessedCandidateCount}}</a>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="col-xs-12" *ngIf="candidateCounts.uploadedCandidateCount > 0">
        <div class="main-box clearfix" style="padding-top: 10px;">
            <div class="main-box-body clearfix">
                <div class="row" [hidden]="!displaySelectDeselectButtonFlag" style="margin-bottom: 15px;">
                    <div class="col-xs-12 clearfix">
                        <div class="pull-left">
                            <button type="button" class="btn btn-info" (click)="toggleSelectAllCandidates()">
                                <span *ngIf="!selectedAllCandidatesFlag">Select All</span>
                                <span *ngIf="selectedAllCandidatesFlag">Deselect All</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <div class="row" class="review-candidate-pull-review-table-header-row">
                            <div class="col-xs-1 review-candidate-pull-review-table-header-text">
                                Select
                            </div>
                            <div class="col-xs-2 review-candidate-pull-review-table-header-text">
                                Name
                            </div>
                            <div class="col-xs-2 review-candidate-pull-review-table-header-text">
                                Phone Number
                            </div>
                            <div class="col-xs-2 review-candidate-pull-review-table-header-text">
                                Email
                            </div>
                            <div class="col-xs-1 review-candidate-pull-review-table-header-text">
                                Score
                            </div>
                            <div class="col-xs-4 review-candidate-pull-review-table-header-text">
                                Status
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="height:300px; overflow-y: auto">
                    <div class="col-xs-12" *ngFor="let candidate of candidatesList">
                        <div class="row review-candidate-pull-review-table-row" [ngClass]="{'review-candidate-pull-associate-candidate-selection-bg': candidate.selectedFlag, 'green-bg': (candidate.candidateMatchedToJob && !candidate.jobMatchManuallyCreated && !candidate.isCandidateDetailsUpdatedForJob), 'light-green-bg': (candidate.jobMatchManuallyCreated || candidate.isCandidateDetailsUpdatedForJob)}">
                            <div class="col-xs-1 text-overflow-ellipsis" *ngIf="!candidate.showOverride">
                                <div class="">
                                    <input type="checkbox" [(ngModel)]="candidate.selectedFlag"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="!candidate.allowManualMatch"
                                        (ngModelChange)="candidateToAssociateToggle(candidate)" />
                                </div>
                            </div>
                            <div *ngIf="candidate.showOverride">
                                <button class="btn btn-primary" style="margin-left:-10px; position:relative; bottom:7px" (click)="showOverrideCandidateSuspensionModal(candidate)">Override</button>
                            </div>
                            <div class="col-xs-2 text-overflow-ellipsis" tooltip="{{candidate.name}}" placement="auto bottom" container="body">
                                {{candidate.name}}
                            </div>
                            <div class="col-xs-2 text-overflow-ellipsis" tooltip="{{candidate.phone}}" placement="auto bottom" container="body">
                                {{candidate.phone}}
                            </div>
                            <div class="col-xs-2 text-overflow-ellipsis" tooltip="{{candidate.email}}" placement="auto bottom" container="body">
                                {{candidate.email}}
                            </div>
                            <div class="col-xs-1" (click)="jobCompare(candidate)">
                                <span tooltip="Threshold Score: {{candidate.jobThresholdScore}}" class="cursor-pointer ml-2" placement="auto bottom-left" container="body"
                                    [ngClass]="{'candidate-job-match-card-intelligence-score-success job-match-card-green-bg': candidate.intelligenceScorePassFlag,
                                    'candidate-job-match-card-intelligence-score-failure': !candidate.intelligenceScorePassFlag}">
                                    {{candidate.score}}
                                </span>
                            </div>
                            <div class="col-xs-4 text-overflow-ellipsis" tooltip="{{candidate.statusOfJobMatch}}" placement="auto bottom-right" container="body">
                                {{candidate.statusOfJobMatch}}
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 text-center my-5" *ngIf="candidatesList.length==0">
                        No Resumes processed!
                    </div>

                </div>
                <div class="row">
                    <div class="col-xs-12 clearfix">
                        <div class="pull-right">
                            <button type="button" class="btn btn-success" style="margin-top:20px" (click)="associateCandidates()" [disabled]="(candidatesToAssociateList.length == 0) || associatingCandidatesFlag">
                                <span *ngIf="!associatingCandidatesFlag">Add Selected Candidates</span>
                                <span *ngIf="associatingCandidatesFlag">Adding Candidates ...</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
